export class HrPayConstantAmountKey {
    private static readonly keyPrefix = 'hrPayConstantAmount';
    public static pageHeader = `${HrPayConstantAmountKey.keyPrefix}.pageHeader`;
    public static value = `${HrPayConstantAmountKey.keyPrefix}.value`;
    public static genCurrencyUuid = `${HrPayConstantAmountKey.keyPrefix}.genCurrencyUuid`;
}
